var ProductOptionalFieldNameEnum;
(function (ProductOptionalFieldNameEnum) {
    ProductOptionalFieldNameEnum["asset"] = "asset";
    ProductOptionalFieldNameEnum["careInstruction"] = "careInstruction";
    ProductOptionalFieldNameEnum["complementaryItem"] = "complementaryItem";
    ProductOptionalFieldNameEnum["customerMaterial"] = "customerMaterial";
    ProductOptionalFieldNameEnum["document"] = "document";
    ProductOptionalFieldNameEnum["filterAttribute"] = "filterAttribute";
    ProductOptionalFieldNameEnum["genericProduct"] = "genericProduct";
    ProductOptionalFieldNameEnum["customerBenefitSummary"] = "customerBenefitSummary";
    ProductOptionalFieldNameEnum["priceInformation"] = "priceInformation";
    ProductOptionalFieldNameEnum["priceUnit"] = "priceUnit";
    ProductOptionalFieldNameEnum["child"] = "child";
    ProductOptionalFieldNameEnum["measureReference"] = "measureReference";
    ProductOptionalFieldNameEnum["measure"] = "measure";
    ProductOptionalFieldNameEnum["packageMeasure"] = "packageMeasure";
    ProductOptionalFieldNameEnum["customerBenefit"] = "customerBenefit";
    ProductOptionalFieldNameEnum["goodToKnow"] = "goodToKnow";
    ProductOptionalFieldNameEnum["peopleAndPlanet"] = "peopleAndPlanet";
    ProductOptionalFieldNameEnum["image"] = "image";
    ProductOptionalFieldNameEnum["video"] = "video";
    ProductOptionalFieldNameEnum["technicalInformation"] = "technicalInformation";
    ProductOptionalFieldNameEnum["complianceTechnical"] = "complianceTechnical";
    ProductOptionalFieldNameEnum["complianceInformation"] = "complianceInformation";
    ProductOptionalFieldNameEnum["complianceLabel"] = "complianceLabel";
    ProductOptionalFieldNameEnum["validDesignPart"] = "validDesignPart";
    ProductOptionalFieldNameEnum["appConfig"] = "appConfig";
})(ProductOptionalFieldNameEnum || (ProductOptionalFieldNameEnum = {}));
export default ProductOptionalFieldNameEnum;
//# sourceMappingURL=ProductOptionalFieldNameEnum.js.map